import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import { setPanelDepth } from '@reducers/options/panel/actions';
import { unitLabel, unitTransform, prepareNum } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { DISTANCE } from '@reducers/units';

const Tfix = props => {
  return (
    <Tooltip content={APP_TOOLTIPS.TOOLTIP_THICKNESS_ANCHOR_PLATE.Content}>
    <Input
      prefix="Tfix ="
      postfix={unitLabel(props.unit)}
      className="base-plate__input_block"
      id="depth"
      type="number"
      minValue={0}
      disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
      value={props.depth}
      onUpdate={value => {
        props.setDepth(value, props.unit);
      }}
    />
    </Tooltip>
  );
};

const mapState = state => {
  const unit = state.main.units.distance;
  const depth = unit === DISTANCE.INCHES ? 
    prepareNum(unitTransform(state.options.panel.depth || 0, false).from(defaultUnits.DISTANCE).to(unit), false, 3) :
    unitTransform(state.options.panel.depth || 0, true).from(defaultUnits.DISTANCE).to(unit);

  return {
    depth,
    unit,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};

const mapDispatch = dispatch => ({
  setDepth: (value, unit) => dispatch(setPanelDepth(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE))),
});

export default connect(mapState, mapDispatch)(Tfix);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Tfix.js